import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

function getAuthHeaders() {
  const token = sessionStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function recordingPath(cameraId, date, filename) {
  return [cameraId, date, filename].map(encodeURIComponent).join("/");
}

export const recordingService = {
  async getRecordings(cameraId) {
    const response = await fetch(
      `${GO_BACKEND_URL}/recordings/${encodeURIComponent(cameraId)}`,
      { headers: { ...getAuthHeaders() } }
    );
    if (!response.ok) {
      throw new Error(`Unable to load recordings (${response.status})`);
    }
    const groups = await response.json();
    if (!Array.isArray(groups)) return [];
    return groups
      .map((group) => ({
        ...group,
        files: [...(group.files || [])].sort((left, right) => {
          const leftTime = Date.parse(left.created_at);
          const rightTime = Date.parse(right.created_at);
          if (Number.isFinite(leftTime) && Number.isFinite(rightTime) && leftTime !== rightTime) {
            return rightTime - leftTime;
          }
          return right.name.localeCompare(left.name);
        }),
      }))
      .sort((left, right) => right.date.localeCompare(left.date));
  },

  getRecordingUrl(cameraId, date, filename) {
    return `${GO_BACKEND_URL}/recordings/${recordingPath(
      cameraId,
      date,
      filename
    )}`;
  },

  async deleteRecording(cameraId, date, filename) {
    const response = await fetch(
      `${GO_BACKEND_URL}/recordings/${recordingPath(cameraId, date, filename)}`,
      {
        method: "DELETE",
        headers: { ...getAuthHeaders() },
      }
    );
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || `Unable to delete recording (${response.status})`);
    }
    return response.json();
  },

  async deleteRecordings(cameraId, recordings) {
    const response = await fetch(
      `${GO_BACKEND_URL}/recordings/${encodeURIComponent(cameraId)}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
        body: JSON.stringify({ recordings }),
      }
    );
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || `Unable to delete recordings (${response.status})`);
    }
    return response.json();
  },
};

export default recordingService;
